import { autoinject } from "aurelia-framework";
import { json } from "aurelia-fetch-client";
import { ApiService } from "../../utils/api-service";
import { IServiceDataItems } from "../customers/reported-service-data-item-service";
import { AttachedDataItem } from "../reported-service-data-items/reported-service-data-item-models";

@autoinject
export class DefaultServiceDataItemService {
	constructor(private api: ApiService) {}

	getDefaultServiceDataItemsForServiceStructure(
		scopeTypeGroupId: string,
		serviceStructureId: string
	): Promise<IServiceDataItems> {
		return this.api.fetchJson(
			`service-structures/${serviceStructureId}/default-measures?scopeTypeGroupId=${scopeTypeGroupId}`
		);
	}

	getDefaultServiceDataItemsForServiceStructureWithCustomers(
		scopeTypeGroupId: string,
		serviceStructureId: string
	): Promise<IServiceDataItems> {
		return this.api.fetchJson(
			`service-structures/${serviceStructureId}/default-measures-with-customers?scopeTypeGroupId=${scopeTypeGroupId}`
		);
	}

	getDefaultServiceDataItemsForService(
		scopeTypeGroupId: string,
		serviceId: string
	): Promise<AttachedDataItem[]> {
		return this.api.fetchJson(
			`services/${serviceId}/default-measures?scopeTypeGroupId=${scopeTypeGroupId}`
		);
	}

	addDefaultServiceDataItem(defaultMeasure: DefaultDataItem): Promise<any> {
		return this.api.fetchJson(
			`services/${defaultMeasure.serviceId}/default-measures/for-scopetypegroup/${defaultMeasure.scopeTypeGroupId}`,
			{
				method: "post",
				body: json(defaultMeasure)
			}
		);
	}

	updateDefaultMeasureInputType(
		serviceId: string,
		measureId: string,
		scopeTypeGroupId: string,
		inputType: string,
		isCollected: boolean
	) {
		return this.api.fetch(
			`services/${serviceId}/default-measures/${measureId}/${inputType}` +
				`/${isCollected}?scopeTypeGroupId=${scopeTypeGroupId}`,
			{
				method: "post"
			}
		);
	}

	removeDefaultMeasure(serviceId: string, defaultMeasureId: string) {
		return this.api.fetch(
			`services/${serviceId}/default-measures/remove/${defaultMeasureId}`,
			{
				method: "delete"
			}
		);
	}

	async changeDataItemDescription(defaultItem: AttachedDataItem): Promise<any> {

		const url = `services/${defaultItem.serviceId}/default-measures/${defaultItem.id}/description/`;

		return await this.api.fetch(url, {
			method: "post",
			body: json(defaultItem.description)
		});
	}

	async updateDataItemCustomerComparisonState(defaultItem: AttachedDataItem): Promise<any> {

		const url = `services/${defaultItem.serviceId}/default-measures/updatecustomercomparisonstate/${defaultItem.id}/${defaultItem.isForCustomerComparison}`;

		return await this.api.fetch(url, {
			method: "post",
			body: json(defaultItem.description)
		});
	}
}

export class DefaultDataItem extends AttachedDataItem {
	scopeTypeGroupId: string;
	customerId?: string | null;
	constructor(init?: Partial<DefaultDataItem>) {
		super();
		Object.assign(this, init);
	}
}
